module.exports = __webpack_public_path__ + "static/media/event_banner.7c015905.png";